import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { rueckweg } from './sitzung';
import { Button, Card, Field, Input, Logo } from '@elbklar/ui';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, loginWithGoogle, error, isLoading } = useAuth();
  // `?ziel=` setzt der API-Client, wenn die Sitzung wirklich vorbei ist: die
  // Seite, auf der man war. Nach der Anmeldung geht es dorthin zurück.
  const [params] = useSearchParams();
  const ziel = rueckweg(params.get('ziel'));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    if (!email || !password) {
      setLocalError('E-Mail und Passwort eingeben.');
      return;
    }

    try {
      await login(email, password);
      navigate(ziel);
    } catch {
      // Error is handled by AuthContext
    }
  };

  const handleGoogleLogin = () => {
    loginWithGoogle(ziel);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <div className="flex flex-col gap-6 p-3">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="flex items-center gap-2">
              <Logo variant="horizontal" height={40} />
              <span className="rounded-full bg-muted px-2 py-0.5 t-label text-muted-foreground">PM</span>
            </div>
            <div>
              <h1 className="t-page-title">Anmelden</h1>
              <p className="mt-1 text-muted-foreground">Willkommen beim Project Management</p>
            </div>
          </div>

          {(error || localError) && <div className="rounded-lg bg-danger-soft px-4 py-3 t-small text-danger">{error || localError}</div>}

          <Button className="w-full" onClick={handleGoogleLogin} disabled={isLoading}>
            <svg className="size-4" viewBox="0 0 24 24" aria-hidden>
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Mit Google anmelden
          </Button>

          <div className="flex items-center gap-4 t-small text-muted-foreground">
            <span className="h-px flex-1 bg-border" />
            oder
            <span className="h-px flex-1 bg-border" />
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <Field label="E-Mail">
              {(f) => (
                <Input
                  {...f}
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  autoFocus
                  disabled={isLoading}
                />
              )}
            </Field>
            <Field label="Passwort">
              {(f) => (
                <Input
                  {...f}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                  disabled={isLoading}
                />
              )}
            </Field>
            <Button type="submit" variant="primary" className="w-full" loading={isLoading}>
              Anmelden
            </Button>
          </form>
        </div>
      </Card>
    </div>
  );
}
